import { isValidMailtoUrl } from 'src/utils/custom-validations';
import { formatUrl, isValidUrl } from 'src/utils/url';

export function checkInputForUrl(value: string): string | undefined {
  if (isValidMailtoUrl(value)) {
    return value;
  } else if (isValidUrl(value)) {
    return formatUrl(value);
  }
}
